import { firstNameValidation, lastNameValidation } from "@/constants/schema";
import { object } from "yup";

export const changeNamesSchema = object({
    firstName: firstNameValidation,
    lastName: lastNameValidation
});
